import React from 'react';
import { SearchAsYouTypeMinimalistic } from '../../../../components/component-book/components/SearchAsYouType/SearchAsYouTypeMinimalistic';
import { remappedCategorizedContentMinimalisticFactory } from '../../../../components/component-book/components/SearchAsYouType/SearchAsYouTypeMinimalistic/remappedCategorizedContentMinimalisticFactory';
import { HeaderMinimalistic } from '../../../../components/component-book/components/CategorizedContent/Header';
import { ItemMinimalistic } from '../../../../components/component-book/components/CategorizedContent/Item';
import { SanitizingWrapper } from './SanitizingWrapper';
import { Brand } from '../../../../common/models/FilterSettings';
import ComponentWrapper from '../../../../components/MediaQuery/ComponentWrapper';
import { searchBoxWithRoundedCornersFactory } from './searchBoxWithRoundedCornersFactory';

/* Interfaces */
export interface BrandsFilterPanelProps {
  brands: (Brand & { selected: boolean })[];
  onItemClicked: (arg: { hidden: boolean; id: string; selected: boolean; value: string }) => void;
  s3BasePath: string;
}

/* Helpers */
const remapBrands = (brands: BrandsFilterPanelProps['brands']) =>
  brands.map(({ name, ...b }) => ({ value: name, ...b }));

/* Components */
export const BrandsFilterPanel: React.FC<BrandsFilterPanelProps> = ({ brands, onItemClicked, s3BasePath }) => {
  const commonProps = {
    content: remapBrands(brands),
    onItemClicked,
    onlyOneItemCanBeSelected: false,
  };

  const desktopProps = {
    ...commonProps,
    headersWithItemsDisplay: {
      component: remappedCategorizedContentMinimalisticFactory({
        estimatedRowSize: 23,
        headers: {
          component: HeaderMinimalistic,
          firstHeaderPaddingOverride: '0px 0 10px 0',
          padding: '16px 0 10px 0',
        },
        initialListWidth: 190,
        items: { component: ItemMinimalistic, padding: '2px 0px' },
        maxHeight: 300,
      }),
    },
    padding: '0 0 0 10px',
    searchBox: {
      component: searchBoxWithRoundedCornersFactory({
        magnifyingGlassSize: { height: '18px', marginRight: '6px' },
        placeholder: 'Search designers',
        s3BasePath,
      }),
      underSearchBoxNode: <div style={{ height: '24px', width: '100%' }} />,
    },
  };

  const mobileProps = {
    ...commonProps,
    headersWithItemsDisplay: {
      component: remappedCategorizedContentMinimalisticFactory({
        estimatedRowSize: 42,
        headers: { component: HeaderMinimalistic, padding: '0' },
        initialListWidth: 190,
        items: { component: ItemMinimalistic, padding: '12px 0' },
        maxHeight: 300,
      }),
    },
    padding: '0 0 0 12px',
    searchBox: {
      component: searchBoxWithRoundedCornersFactory({
        magnifyingGlassSize: { height: '18px', marginRight: '2px' },
        placeholder: 'Search designers',
        s3BasePath,
        size: { height: '40px', width: '100%' },
      }),
      underSearchBoxNode: <div style={{ height: '30px', width: '100%' }} />,
    },
  };

  return (
    <SanitizingWrapper className="icb">
      <ComponentWrapper desktopProps={desktopProps} mobileProps={mobileProps} type={SearchAsYouTypeMinimalistic} />
    </SanitizingWrapper>
  );
};
